import { render, staticRenderFns } from "./payback-detail.vue?vue&type=template&id=621fc928&scoped=true&"
import script from "./payback-detail.vue?vue&type=script&lang=js&"
export * from "./payback-detail.vue?vue&type=script&lang=js&"
import style0 from "./payback-detail.vue?vue&type=style&index=0&id=621fc928&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621fc928",
  null
  
)

export default component.exports